import { environment } from '../../environments/environment';

const imagesFolder = `images/`;
const groupFolder = `grupo-san-cristobal/`;

export const groupLogo = `${environment.cdn.commonUrl}${imagesFolder}${groupFolder}logo-grupo-373×98.svg`;
export const groupLogoMobile = `${environment.cdn.commonUrl}${imagesFolder}${groupFolder}logo-gsc-119×42.svg`;
export const groupLogoNegative = `${environment.cdn.commonUrl}${imagesFolder}${groupFolder}logo-grupo-negativo-384x101.svg`;
